<template>
  <v-slide-y-reverse-transition>
    <v-card
      v-if="showBanner"
      class="d-flex align-center justify-space-between banner px-3 px-md-7 py-5 rounded-b-0"
      color="primary"
      elevation="24"
    >
      <span class="message mr-1">
        {{ $translate('COOKIE_TEXT') }}
        <a @click="readMore()">
          {{ $translate('READ_MORE') }}
        </a>
      </span>
      <v-btn
        @click="onContinue()"
        color="secondary"
        class="secondary-font-color text-capitalize px-4 px-md-8"
        depressed
        height="34px"
      >
        {{ $translate('ACCEPT') }}
      </v-btn>
    </v-card>
  </v-slide-y-reverse-transition>
</template>

<script>
export default {
  name: 'CookieBar',
  data() {
    return {
      showBanner: false,
    };
  },
  mounted() {
    console.log('cookieBar', this.$store.getters['auth/cookieBar']);
    if (this.$store.getters['auth/cookieBar']) {
      this.showBanner = true;
    }
  },
  methods: {
    readMore() {
      this.showBanner = false;
      this.$router.push({ name: 'PrivacyStatement' });
    },
    onContinue() {
      this.$store.commit('auth/setCookieBar', false);
      this.showBanner = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.banner {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 91;
}
.message {
  color: white;
}
a {
  color: lightgray !important;
  transition: 0.2s;
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
}
</style>
